









































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Limit from '@/dto/limits/Limit'
import limitsStore from '@/stores/LimitsStore'
import LimitsTableHeader from '@/components/limits/LimitsTableHeader.vue'
import LimitsTableRow from '@/components/limits/LimitsTableRow.vue'
import Country from '@/dto/deliveries/Country'
import LocationService from '@/services/LocationService'
@Component({
  components: { LimitsTableRow, LimitsTableHeader },
})
export default class LimitsTable extends Vue {
  @Prop(Array)
  public limits!: Limit[]

  limitsStore = limitsStore
  countries: Country[] = []

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'countryId',
      align: 'left',
      label: 'Страна',
      field: 'countryId',
      sortable: true,
    },
    {
      name: 'limit',
      align: 'left',
      label: 'Лимит',
      field: 'limit',
      sortable: true,
    },
    {
      name: 'currency',
      align: 'left',
      label: 'Валюта',
      field: 'currency',
      sortable: true,
    },
    {
      name: 'actions',
      align: 'left',
      label: '',
      field: 'actions',
    },
  ]

  created() {
    LocationService.getCountries().then(
      countries => (this.countries = countries)
    )
  }

  get selectedLimit(): Limit | null {
    return this.limitsStore.limit
  }

  get selectedRow() {
    return this.selectedLimit ? [this.selectedLimit] : []
  }
}
